import { useState, useEffect } from 'react';
import axios from '../../../../api/axios';

/**
 * 提交历史管理 Hook
 * 负责获取和管理题目的提交记录
 */
export function useSubmissions(questionId) {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Early return if questionId is invalid or undefined
    if (!questionId || questionId === 'undefined' || questionId === 'null') {
      setLoading(false);
      setError(null);
      setSubmissions([]);
      return;
    }
    fetchSubmissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);

  const fetchSubmissions = async () => {
    // Early return if questionId is invalid
    if (!questionId || questionId === 'undefined' || questionId === 'null') {
      setLoading(false);
      setError('题目ID无效');
      setSubmissions([]);
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`/submissions/question/${questionId}`);
      setSubmissions(response.data || []);
    } catch (error) {
      console.error('Error fetching submissions:', error);
      setError(error.response?.data?.error || '获取提交记录失败');
    } finally {
      setLoading(false);
    }
  };

  const addSubmission = (submission) => {
    setSubmissions(prev => [submission, ...prev]);
  };

  return {
    submissions,
    loading,
    error,
    refetch: fetchSubmissions,
    addSubmission
  };
}

